<script>
import Spinner from 'shared/components/Spinner.vue';

export default {
  components: {
    Spinner,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    buttonText: {
      type: String,
      default: '',
    },
    buttonClass: {
      type: String,
      default: '',
    },
    iconClass: {
      type: String,
      default: '',
    },
    spinnerClass: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'submit',
    },
  },
  computed: {
    computedClass() {
      return `button nice gap-2 ${this.buttonClass || ' '}`;
    },
  },
  methods: {
    onClick() {
      this.$emit('click');
    },
  },
};
</script>

<template>
  <button
    :type="type"
    data-testid="submit_button"
    :disabled="disabled"
    :class="computedClass"
    @click="onClick"
  >
    <fluent-icon v-if="!!iconClass" :icon="iconClass" class="icon" />
    <span>{{ buttonText }}</span>
    <Spinner v-if="loading" class="ml-2" :color-scheme="spinnerClass" />
  </button>
</template>

<style lang="scss" scoped>
// O `opacity-100` aqui cancela de proposito o `opacity-40` que `.button:disabled`
// aplica: em vez de esmaecer o botao inteiro, o desabilitado deste usa um azul
// claro proprio. Passou a `brand-subtle` com `brand-text`, o mesmo par do resto
// do sistema -- antes era `bg-woot-100` com `dark:text-slate-500`, o que no tema
// escuro dava cinza-medio sobre azul translucido.
button:disabled {
  @apply bg-brand-subtle text-brand-text opacity-100;

  &:hover {
    @apply bg-brand-subtle;
  }
}
</style>
